let price = require('../../../actions/order/price');
let utils = require('../../../actions/utils');
let { setFilterValuesChanged } = require('../../../actions/custom-order');

module.exports = {
    calcPriceGroup: [
        setFilterValuesChanged,
        utils.unset(['order', 'price', 'isZero']),
        price.prepareToRequest,
        [
            price.calcPrice,
            {
                requiredParametersNotFilled: [
                    utils.set(['order', 'price', 'isError'], false),
                    price.initPrice,
                    price.setIsLoading(false)
                ],
                success: [
                    price.setPriceIfRequestIdIsValid,
                    utils.set(['order', 'price', 'isError'], false),
                    [
                        price.isZeroPrice,
                        {
                            yes:[
                                utils.set(['order', 'price', 'isZero'], true)
                            ],
                            no: []
                        }
                    ]
                ],
                error: [
                    utils.set(['order', 'price', 'isError'], true)
                ]
            }
        ],
        utils.set(['order', 'tooltip', 'hideDataChangeTooltip'], true)
    ]
};



// WEBPACK FOOTER //
// ./signals/groups/order/price.js